import ServiceCaller from "../../../services/ServiceCaller";


export default class CategoryRepository {
    async all(shopId: string): Promise<any> {
        return new ServiceCaller().getService().categories(shopId)
    }
}
